import Vue from 'vue'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {make} from 'vuex-pathify'
import {crudifyMutations, byId, hydrateEdit, resetState, resetResults, savePayload} from 'src/utilities/vuex2'
import {OK} from 'http-status-codes'
import Constants from 'src/utilities/constants'
import _ from 'lodash'
import {maybeAppendInactive} from '@/utilities/utils'

const initialState = {
  edit: {
    id: null,
    name: null,
    clientIds: [],
    builderIds: [],
    active: true,
    createdBy: null,
    updatedBy: null,
    createdAt: null,
    updatedAt: null
  },
  autocompleteResultsCommunity: [],
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.byId = byId
getters.savePayload = savePayload
getters.autocompleteResultsCommunityById = (state) => (id) => {
  return objectById(state.autocompleteResultsCommunity, id)
}

const mutations = make.mutations(state)
mutations.reset = resetState
mutations.resetResults = resetResults
mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    clientIds: [],
    builderIds: [],
    active: true
  }
}
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = JSON.parse(JSON.stringify(initialState.edit))
}

mutations.addClient = (state, clientId) => {
  if (!state.edit.clientIds.includes(clientId)) {
    state.edit.clientIds.push(clientId)
  }
}

mutations.addBuilder = (state, builderId) => {
  if (!state.edit.builderIds.includes(builderId)) {
    state.edit.builderIds.push(builderId)
  }
}

mutations.deleteClient = (state, clientIdToDelete) => {
  state.edit.clientIds = _.filter(state.edit.clientIds, (clientId) => clientId !== clientIdToDelete)
}

mutations.deleteBuilder = (state, builderIdToDelete) => {
  state.edit.builderIds = _.filter(state.edit.builderIds, (builderId) => builderId !== builderIdToDelete)
}

mutations.resetAutocompleteResults = (state) => {
  state.autocompleteResultsCommunity = []
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByNameStartsWith({commit}, payload) {
      const response = await ptracGetEntities(`communities/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=${encodeURIComponent(payload)}`)

      if (OK === response.status) {
        commit('autocompleteResultsCommunity', maybeAppendInactive(response.data))
      }

      return response
    },
    async fetchFindByClientIdsOrBuilderIds({}, companyId) {
      return await ptracGetEntities('communities/search/findByClientIdsOrBuilderIds?clientIds=' + companyId + '&builderIds=' + companyId)
    },
    async fetchByName({ state, dispatch }, payload) {
      const url = `communities/search/findByNameStartsWithIgnoreCaseAndActiveOrderByNameAsc?name=${encodeURIComponent(payload.query)}&active=${payload.active}`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.results = response.data

        const builderIds = state.results.map(community => community.builderIds).flat()

        if (builderIds && builderIds.length > 0) {
          await dispatch('companies/fetchByIdsToMap', {
            ids: builderIds,
            type: Constants.COMPANY.TYPES.BUILDER.toLowerCase()
          }, {root: true})
        }

        const clientIds = state.results.map(community => community.clientIds).flat()

        if (clientIds && clientIds.length > 0) {
          await dispatch('companies/fetchByIdsToMap', {
            ids: clientIds,
            type: Constants.COMPANY.TYPES.CLIENT.toLowerCase()
          }, {root: true})
        }
      }

      return response
    }
  }
}
